export const notAvailable = ({ value }) => {
    return value ? value : '-';
};
